// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lGIg","high":"styles_high__VzWKp","medium":"styles_medium__3V-TS","low":"styles_low__1qUEU","valueIcon":"styles_valueIcon__3kt7U"};